import React from 'react';
import debounce from 'lodash-es/debounce';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';

const CREATIVE_ID = 'table_markdown';
const SCROLL_DEBOUNCE_TIMEOUT = 500;

export function MarkdownTable(props) {
  const handleTableScroll = debounce(event => {
    const boundingClientRect = event?.target?.getBoundingClientRect();
    const widgetHeight = boundingClientRect?.height;
    const widgetOffset = boundingClientRect?.top;

    EventToolbox.fireTrackAction({
      event_type: TrackingConstant.EVENT_TYPE_WIDGET_VIEW,
      event_data: {
        action_name: TrackingConstant.ACTION_WIDGET_VIEW,
        action_cause: TrackingConstant.ACTION_CAUSE_SCROLL,
        total_page_height: Math.max(document.body.scrollHeight, document.body.offsetHeight),
        widget_height: Math.round(widgetHeight),
        widget_y_position: Math.round(widgetOffset),
        creative_id: CREATIVE_ID,
      },
    });
  }, SCROLL_DEBOUNCE_TIMEOUT);

  return <table {...props} data-tracking-parent={CREATIVE_ID} onScroll={handleTableScroll} />;
}
